/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_V2_Theme_DescriptionInputs */

const en_settings_v2_theme_description = /** @type {(inputs: Settings_V2_Theme_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applies across the app`)
};

const es_settings_v2_theme_description = /** @type {(inputs: Settings_V2_Theme_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se aplica en toda la aplicación`)
};

/**
* | output |
* | --- |
* | "Applies across the app" |
*
* @param {Settings_V2_Theme_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_v2_theme_description = /** @type {((inputs?: Settings_V2_Theme_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_V2_Theme_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_v2_theme_description(inputs)
	return en_settings_v2_theme_description(inputs)
});